// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36-Ka","colBig":"styles_colBig__3aID2","colSmall":"styles_colSmall__PK82b"};